import { Drawer } from "@blueprintjs/core";
import { type ItemCreateDrawerProps } from "@package/ui-apollo-components";
import { TagEdit } from "./TagEdit";

export function TagCreateDrawer({
  isOpen,
  onCreated,
  onClose,
}: ItemCreateDrawerProps) {
  return (
    <Drawer isOpen={isOpen} className="bg-slate-100 overflow-auto px-4 pb-4">
      <TagEdit
        toolbarProps={{
          onCanceled: onClose,
          onDeleted: () => {},
          onCreated: (id) => {
            onCreated(id);
            onClose();
          },
        }}
      />
    </Drawer>
  );
}
